<template>
  <div>
    <v-layout>
      <v-text-field
        :label="$t('Credit-Card-No')"
        @blur="codeControl()"
        append-icon="search"
        @click:append="dialogac()"
        v-model="val"
        :placeholder="kodmesajı"
        hide-details=""
      ></v-text-field>
    </v-layout>

    <v-dialog scrollable="" v-model="dialog" max-width="550px">
      <v-card color="grey lighten-2">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">
               <span v-if="kartTipi == 2">{{ $t('Search-Client-Card') }} </span>
              <span v-if="kartTipi == 1">  {{ $t('Search-Corporate-Card') }} </span>
              <span v-if="kartTipi == 2"> {{ $t('Search-Client-Card') }} </span>
            </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            solo
            hide-details
            autofocus=""
            ref="ara"
            v-model="secilendeger"
            :label="$t('Please-enter-3-letters')"
            append-icon="search"
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">
            <div class="flex md12">
              <v-data-table
                :headers="headersKrediKart"
                :loading="progress"
                :items="itemsKrediKart"
                hide-actions
                class="elevation-1"
              >
                <v-progress-linear
                  slot="progress"
                  indeterminate
                ></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr @click="kabul(props.item.kredikartno)" item>
                    <td class="text-xs-left">{{ props.item.kredikartno }}</td>
                    <td class="text-xs-left">{{ props.item.kktip }}</td>
                    <td class="text-xs-left">{{ props.item.ay }}</td>
                    <td class="text-xs-left">{{ props.item.yil }}</td>
                    <td class="justify-center layout px-0"></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            {{ $t("cancel_button") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import tool from "../../coper/tools";

export default {
  props: ["value", "kartTipi"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
  data() {
    return {
      kodmesajı: null,
      dialog: false,
      progress: false,
      headersKrediKart: [
        {
          text: this.$t('Card-No'),
          value: "kredikartno",
        },
        {
          text: this.$t('Card-Type-v2'),
          value: "kktip",
        },
        {
          text: this.$t('Month'),
          value: "ay",
        },
        {
          text: this.$t('YEAR'),
          value: "yil",
        },
      ],
      SearchText: null,
      itemsKrediKart: [],
      text1: null,
      snackbar: false,
      secilendeger: null,
    };
  },
  methods: {
    araKrediKart(text) {
      let params = {
        KartTipi: this.kartTipi, //FirmaKartli = 1, MusteriKartli = 2
        KartNo: text,
      };
      if(this.kartTipi == 0){
       params.KartTipi = 2;     
      }
      tool.http_post(this, "KartArama", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.itemsKrediKart = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },

        (response) => {
          this.text1 = this.$t('An-error-has-occurred-Please-try-again');
          this.snackbar = true;
        }
      );
    },
    kabul(krediKartNo) {
      this.val = krediKartNo;
      this.dialog = false;
    },
    dialogac() {
      this.dialog = true;
    },
    codeControl() {
      if (this.val != null && this.val != "" && this.kartTipi != 0 && this.kartTipi != 2) {
        let params = {
          KartTipi: this.kartTipi, //FirmaKartli = 1, MusteriKartli = 2
          KartNo: escape(this.val),
        };
        

        tool.http_post(this, "KartArama", params).then(
          (response) => {
            if (response.body.data.length == 1) {
              this.val = response.body.data[0].kredikartno;
              this.kodmesajı = null;
            } else {
              this.kodmesajı = this.$t('Incorrect-code-entry')
              this.val = null;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-referans";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-referans";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
      } else {
        this.kodmesajı = null;
      }
    },
  },
  watch: {
    secilendeger(text) {
      text && this.araKrediKart(text);
    },
  },
};
</script>